var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotateSmartphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 488.6 488.6",
    style: {
      enableBackground: "new 0 0 488.6 488.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.2,285.8v168.2c0,19.1,15.6,34.7,34.7,34.7H216c-6-10.2-9.7-22-9.7-34.6l-161.5,0.1c0,0-0.1,0-0.1,0 l-0.1-168.3l161.6-0.1v-34.6H44.9C25.7,251.1,10.2,266.6,10.2,285.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.9,135.4v318.6c0,19.1,15.6,34.7,34.7,34.7h87.8h80.3c19.1,0,34.7-15.6,34.7-34.7V135.4 c0-19.1-15.6-34.7-34.7-34.7H275.6C256.5,100.7,240.9,116.2,240.9,135.4z M443.9,419.3H275.5l-0.1-284l168.3-0.1L443.9,419.3z  M359.7,471.4c-10.1,0-18.3-8.2-18.3-18.3c0-10.1,8.2-18.3,18.3-18.3c10.1,0,18.3,8.2,18.3,18.3C378,463.1,369.8,471.4,359.7,471.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.1,34.6c9.5,0,17.3-7.7,17.3-17.3c0-9.5-7.7-17.3-17.3-17.3C151.8,0,93.6,57.4,92.3,128.5H69 c-1.7,0-3.2,1-3.8,2.6c-0.6,1.5-0.3,3.3,0.9,4.5l40.4,40.5c1.6,1.6,4.2,1.6,5.8,0l40.4-40.5c1.2-1.2,1.5-3,0.9-4.5 c-0.6-1.6-2.1-2.6-3.8-2.6h-23.1C128.2,76.5,170.8,34.6,223.1,34.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateSmartphone);
export default __webpack_public_path__ + "static/media/rotate-smartphone.7c1147f3fc9c14dec9bdbb0e8cb658dd.svg";
export { ForwardRef as ReactComponent };